import { Grid, Typography } from "@mui/material";

import SaveButton from "./SaveButton";
import SendButton from "./SendButton";
import AddImageButton from "./AddImageButton";
import ChangeBackgroundButton from "./ChangeBackgroundButton";
type ToolButtonsProps = {
  stageRef: React.MutableRefObject<null>;
  setImgSrc: React.Dispatch<React.SetStateAction<string | ArrayBuffer | null>>;
  setBackgourndSrc: React.Dispatch<
    React.SetStateAction<string | ArrayBuffer | null>
  >;
};

const ToolButtons: React.FC<ToolButtonsProps> = ({
  stageRef,
  setImgSrc,
  setBackgourndSrc,
}) => {
  return (
    <Grid container direction="column" spacing={1}>
      <ChangeBackgroundButton
        setBackgourndSrc={setBackgourndSrc}
      ></ChangeBackgroundButton>
      <AddImageButton setImgSrc={setImgSrc} />
      <Grid item>
        <Typography variant="h5" align="left">
          完成
        </Typography>
      </Grid>
      <SaveButton stageRef={stageRef} />
      <SendButton stageRef={stageRef} />
    </Grid>
  );
};

export default ToolButtons;
